.section {
  margin: 16px 0;
}

.small {
  font-size: 12px;
}

.tiny {
  font-size: 11px;
}

.fullWidth {
  width: 100%;
}

/* 空状态占住图表的高度，卡片不塌陷 */
.chartEmpty {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 350px;
  margin: 0;
}

.detailFilters {
  padding: 16px;
  margin-bottom: 16px;
  background: var(--ant-color-fill-alter);
  border-radius: var(--ant-border-radius-lg);
}

.filterLabel {
  margin-bottom: 8px;
  font-weight: 600;
}

.filterActions {
  margin-top: 16px;
  text-align: right;
}
